import "./toast.scss";

import { FunctionComponent, useEffect } from "react";
import { AlertTriangle, CheckCircle2, Info, X, XCircle } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../../features/helpers";
import { setToastStatus } from "../../store/ToastSlice";

/** Tempo em tela antes de sumir sozinho. */
const AUTO_DISMISS_MS = 4000;

const ICONS: Record<string, typeof Info> = {
    success: CheckCircle2,
    error:   XCircle,
    warning: AlertTriangle,
    info:    Info,
};

const Toast : FunctionComponent = () => {

    const dispatch  = useAppDispatch();
    const show      = useAppSelector((state) => state.toast.show);
    const toastInfo = useAppSelector((state) => state.toast.toastInfo);

    // Fecha sozinho. Sem isto o toast ficaria na tela para sempre: nenhum ponto
    // do app despacha setToastStatus(false).
    useEffect(() => {
        if (!show) return;
        const timer = setTimeout(() => dispatch(setToastStatus(false)), AUTO_DISMISS_MS);
        return () => clearTimeout(timer);
    }, [show, toastInfo, dispatch]);

    const Icon = ICONS[toastInfo.effect] ?? Info;

    return (
        // A classe `active` e o que traz o toast para dentro da tela: o CSS o
        // mantem em `top: -100px` sem ela. O componente sempre fica montado
        // para a transicao de entrada e saida acontecer.
        <div
            className={`toast-wrapper ${toastInfo.effect} ${show ? "active" : ""}`.trim()}
            role="status"
            aria-live="polite"
        >
            <span className="toast-icon"><Icon size={18} /></span>

            <div className="toast-text">
                <h1>{toastInfo.title}</h1>
                <p>{toastInfo.message}</p>
            </div>

            <button
                type="button"
                className="toast-close"
                aria-label="Fechar aviso"
                onClick={() => dispatch(setToastStatus(false))}
            >
                <X size={15} />
            </button>
        </div>
    )
}

export default Toast;
